export default __webpack_public_path__ + "static/media/025-supermarket.e5217c20.svg";